import React from "react"
import FieldFormElementView, {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";
import {DateRangeRelativeValue} from "../date-range-relative";
import FieldDateRelative from "../../date-relative/date-relative";
import {FIELDS} from "../../../../fields.const";


export default function FieldDateRangeRelative_FormElementView(props: FieldFormElementViewProps) {

    const curModelValue = props.field.getViewValue(props.model)
    // we dont want issues with object references
    const value : DateRangeRelativeValue = curModelValue ? _.clone(curModelValue) : { start   : 0,  end     : 0}

    // console.log("current Value = ",value)

    const onStartChange = (start:number) => {
        value.start = start
        if (props.onChange) props.onChange(value)
    }

    const onEndChange = (end:number) => {
        value.end = end
        if (props.onChange) props.onChange(value)
    }

    const fieldStart = new FieldDateRelative({
        type        : FIELDS.DATE_RELATIVE,
        fieldId     : 'start'
    })

    const fieldEnd = new FieldDateRelative({
        type        : FIELDS.DATE_RELATIVE,
        fieldId     : 'end'
    })

    return (
        <div className={Classes("flex-row-left-center", props.className)}>
            <FieldFormElementView field={fieldStart} model={value} onChange={onStartChange} className="w-140"/>
            <div className="ui5-txt-not-important-small m-l-5 m-r-5">-</div>
            <FieldFormElementView field={fieldEnd} model={value} onChange={onEndChange} className="w-140" />
        </div>
    )

}